(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore', 'torso/modules/Collection', './SecureMessageModel', 'services/messageExtService', './messageService', 'app/utils/partialListUtils'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var messageExtService = require('./../urls').messageExtService;
    var _ = require('underscore');
    module.exports = factory(_, require('backbone-torso/modules/Collection'), require('./SecureMessageModel'), messageExtService, require('./messageService'), require('./../utils/partialListUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(_, TorsoCollection, SecureMessageModel, messageExtService, messageService, partialListUtils) {
  'use strict';

  var SORT_TYPE = {
    PAYABLE_BILLS: 'PAYABLE_BILLS'
  };

  /**
   * Receives messages from the MessageExtService which serves the MessageDTO resource
   * @class SecureMessageCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: SecureMessageModel,
    url: messageExtService,
    fetchHttpAction: 'POST',

    _sortByType: null,
    _promotedItem: null,

    /**
     * @property SORT_TYPE {Object} hash from named secure message status to value of the status in a secure message.
     *   @property SORT_TYPE.PAYABLE_BILLS {String} Bills that are unpaid and should be displayed on make payment page.
     */
    SORT_TYPE: SORT_TYPE,

    /**
     * @method parse
     * @param response {Object} the response that was received from the server.
     * @override
     */
    parse: partialListUtils.convertPartialListResponseToList,

    /**
     * Get a criteria object which should return a particular appointment for a given patient
     * @method getCriteriaForAppointmentIdAndExternalId
     * @param patientVecnaId {String} vecnaId of the patient owning the appointment
     * @param appointmentExternalId {String|String[]} externalId(s) of the appointment
     * @return {Object} criteria object
     */
    getCriteriaForAppointmentIdAndExternalId: messageService.getCriteriaForAppointmentIdAndExternalId,

    /**
     * Fetch a list of secure message IDs by criteria
     * @method fetchIdsByCriteria
     * @param criteria {String} criteria suitable for the messageExtService
     * @return A Promise wrapping a list of ids
     */
    fetchIdsByCriteria : function(criteria) {
      return messageService.fetchMessageIdsByCriteria(criteria)
        .then(partialListUtils.convertPartialListResponseToList);
    },

    /**
     * Get the secure message by it's vecna id.
     * @method getMessageByVecnaId
     * @param vecnaId {String} the vecna id to get the message by.
     * @return {SecureMessageModel}
     */
    getMessageByVecnaId: function(vecnaId) {
      return this.findWhere({ vecnaId: vecnaId });
    },

    /**
     * Get account balances and generate total for patient.
     * @method getTotalAmountDue
     * @return Total {Number} of all account balances for active patient.
     */
    getTotalAmountDue: function(){
      var totalAmountDue = this.reduce(function(amountSum,secureMessageModel){
        if(secureMessageModel.get('type') === 'BILL' && secureMessageModel.get('billDTO.externalBill.status') === 'UNPAID'){
          var itemAccountBalance = secureMessageModel.get('billDTO.externalBill.accountBalance');
          itemAccountBalance = itemAccountBalance || 0;
          amountSum += Number(itemAccountBalance);
        }
        return amountSum;
      }, 0);
      return totalAmountDue;
    },

    /**
     * Sets the _sortByType for use by the comparator method.
     * @method setSortByType
     */
    setSortByType: function(sortByType, promotedItem) {
      this._sortByType = sortByType;
      this._promotedItem = promotedItem;
      this.sort();
    },

    /**
     * Checks for SORT_TYPE and then runs coordinating comparator helper function.
     * @method comparator
     * @override
     * @param firstSecureMessageModel {Object} one model (passed through to helper function)
     * @param secondSecureMessageModel {Object} the other model (passed through to helper function)
     */
    comparator: function(firstSecureMessageModel, secondSecureMessageModel) {
      if (this._sortByType === SORT_TYPE.PAYABLE_BILLS) {
        return this.payableBillsSort(firstSecureMessageModel, secondSecureMessageModel);
      }
    },

    /**
     * Helper method for comparator.
     * Sorts payable bills, selected item first, then the rest in descending order from newest to oldest.
     * @method payableBillsSort
     * @param firstSecureMessageModel {Object} one model (passed through from comparator method)
     * @param secondSecureMessageModel {Object} the other model (passed through from comparator method)
     */
    payableBillsSort: function(firstSecureMessageModel, secondSecureMessageModel) {
      var comparatorValue;

      if (firstSecureMessageModel.get('servicesId') === this._promotedItem){
        comparatorValue = -1;
      } else if (secondSecureMessageModel.get('servicesId') === this._promotedItem) {
        comparatorValue = 1;
      } else {
        var compareDate1 = firstSecureMessageModel.get('billDTO.externalBill.serviceDate');
        var compareDate2 = secondSecureMessageModel.get('billDTO.externalBill.serviceDate');

        if (compareDate1 < compareDate2) {
          comparatorValue = 1;
        } else if (compareDate1 > compareDate2) {
          comparatorValue = -1;
        } else {
          comparatorValue = 0;
        }
      }
      return comparatorValue;
    }
  }))();
}));
